<template lang="pug">
  v-card(
    @click="path"
  ).sdo-card.card-hover.fill-height.d-flex

    v-img(
      :lazy-src="require('@/assets/course-sample.png')"
      :src="course.image ? course.image.url : require('@/assets/course-sample.png')"
      max-height="180"
      alt="Изображение курса"
    ).text-right

      v-chip(v-if="course.type_activity_name" color="primary" label).ma-2.
        {{ course.type_activity_name }}

      tooltip-wrap( text="Страница курса")
        v-btn.mr-6.mt-4(
          v-if="editable"
          fab depressed small
          color="secondary"
          @click.stop.prevent="to"
        ): v-icon(small) mdi-page-layout-body

    .pa-4.pb-0
      .caption.d-flex.align-center.grey--text.text--darken-2
        v-col(cols="auto").pa-0.mr-3
          v-icon.mr-2(color="black" size="20") mdi-image-filter-none
          span {{ $tc('units', course.course_units_count) }}
        v-col(cols="auto").pa-0.mr-4
          tooltip-wrap(
            text="Продолжительность курса"
          )
            v-icon.mr-2(color="black" size="20") mdi-clock-outline
            span {{ $tc('hours', course.duration) }}
        v-col(cols v-if="group").text-truncate.text-end.pa-0
          v-tooltip(top)
            template(v-slot:activator="{ on }" top)
              v-icon.mr-2(v-on="on" color="black" size="20") mdi-school-outline
              span() {{ group.short_name }}
            span Группа
    v-card-title.text-body-1.black--text.pt-3
       span.card-title  {{ course.title }}

    template(v-if="isExchange")
      v-row(v-if="course.price")
        v-col.text-center
          v-tooltip(top)
            template(v-slot:activator="{ on }")
              span(v-on="on")
                | Стоимость: {{ course.price || 0 }}
                v-icon(left) mdi-currency-rub
            span Стоимость курса

    v-card-actions.pa-0.mx-2(v-if="$user.isAuthenticated && false")
      v-btn(
        v-if="$user.data.role === $conf.ROLES.organization.value && isExchange"
        :to="{ name: 'NewCourseRequest', params: { id: course.id }}"
        color="primary"
        depressed
        rounded
        large
      ) Купить
      .d-flex.align-center.fill-width(v-if="canEnroll")
        template(v-if="course.is_related_pfdo")
          v-spacer
          .flex-grow.text-right.d-flex
            .caption Запись доступна только в ПФДО
            v-icon.ml-2 mdi-information
      template(
        v-if="editable"
      )
        v-btn.px-3(
          outlined
          rounded
          color="secondary"
          @click.stop="$router.push({ name: 'CourseEnrollment', params: { id: course.id }})"
        ) К наборам
        v-spacer

        tooltip-wrap(
          text="Настройки курса"
        )
          v-btn(
            fab small
            depressed
            color="secondary"
            @click.stop="$router.push({ name: 'CourseSettings', params: { id: course.id }})"
          )
            v-icon(small) mdi-cog

</template>

<script>
import anime from 'animejs';

import { COURSE_STATUSES } from '@/utils/constants';

export default {
  name: 'CourseCard',
  components: {
  },
  props: {
    course: {
      type: Object,
      default: () => ({}),
    },
    group: {
      type: Object,
      default: () => ({}),
    },
    isExchange: {
      type: Boolean,
      default: false,
    },
    editable: { type: Boolean, default: false },
    study: { type: Boolean, default: false },
    // curator: { type: Boolean, default: false },
  },
  data: () => ({
    COURSE_STATUSES,
    loading: false,
  }),
  computed: {

    organizationShortName() {
      if (!this.course.organizations) return null;
      const [mainOrganization] = this.course.organizations;
      return mainOrganization && mainOrganization.short_name;
    },
    courseCountLessons() {
      return this.course.lessons.length;
    },
    canEnroll() {
      return [
        this.$conf.ROLES.student.value,
        this.$conf.ROLES.listener.value,
      ] === this.$user.data.role && !this.isExchange;
    },
  },
  mounted() {
    this.animateCoursesDisplay();
  },
  methods: {
    to() {
      this.$router.push({ name: 'CourseManagementConstructor', params: { id: this.course.id } });
    },
    path() {
      let path;
      if (this.study) {
        path = {
          name: 'EducationCourseUnitList',
          params: { courseId: this.course.id, groupId: this.course.user_group_id },
        };
      } else if (this.editable) {
        path = { name: 'CourseUnits', params: { id: this.course.id } };
      } else {
        path = { name: 'CourseView', params: { id: this.course.id } };
      }
      this.$router.push(path);
    },
    animateCoursesDisplay() {
      anime({
        targets: '.course-card',
        translateY: [300, 0],
        opacity: [0, 1],
        duration: 600,
        autoplay: true,
        easing: 'easeOutExpo',
        delay: anime.stagger(100),
      });
    },
  },
};
</script>

<style lang="scss" scoped>

  .card-hover {
    cursor: pointer;
    transition: all .2s;

    &:hover {
      transform: scale(1.01);
    }
  }
  .card-title {
    overflow: hidden;
    display: flex;
    white-space: initial;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    text-overflow: ellipsis;
  }
</style>
